import { render, staticRenderFns } from "./el-carousel.vue?vue&type=template&id=2b9f50d1"
import script from "./el-carousel.vue?vue&type=script&lang=js"
export * from "./el-carousel.vue?vue&type=script&lang=js"
import style0 from "./el-carousel.vue?vue&type=style&index=0&id=2b9f50d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports